import {
  Transaction,
  TransactionEntryType,
  TransactionType,
} from '@tcs/client-portal-api/types/Transaction';
import formatPrioritizedValue from '@tcs/common/utils/formatPrioritizedValue';
import formatDate from '@tcs/common/utils/formatDate';

export const formatAmount = (transaction: Transaction) => {
  if (transaction.entryType === TransactionEntryType.DEBIT) {
    return -transaction.amount;
  } else if (transaction.entryType === TransactionEntryType.CREDIT) {
    return transaction.amount;
  }

  if (
    transaction.transactionType === TransactionType.NOTEPAYMENTOFINTEREST ||
    transaction.transactionType === TransactionType.SHARESDISTRIBUTION
  ) {
    return transaction.amount;
  }
  return undefined;
};

const transformDebitCredit = (transactions: Transaction[]) =>
  transactions.map(mapTransactionInfo);

function mapTransactionInfo(transaction) {
  let secondaryInfo = '';

  // Check for secondary lines to display
  if (transaction.depositClearDate) {
    // it we have a clear date in the future, the deposit has not cleared and will
    // not be used in the calculation of available cash on the main overview tab
    const clearDate = new Date(transaction.depositClearDate.split('T')[0]);
    if (clearDate > new Date()) {
      clearDate.setDate(clearDate.getDate() + 1);
      secondaryInfo = 'Available by ' + formatDate(clearDate.toUTCString());
      transaction.pending = true;
    }
  }

  return {
    ...transaction,
    amount: formatAmount(transaction),
    description: formatPrioritizedValue(transaction.description, secondaryInfo),
  };
}

export default transformDebitCredit;
